import '../../styles/dem-theme-lab.css';

const KPI = [
  { key: 'po', label: 'PO', value: '42', meta: 'Desktop / email', tone: 'po' },
  { key: 'manual', label: 'Manual', value: '18', meta: 'Call-in', tone: 'manual' },
  { key: 'b2b', label: 'B2B', value: '27', meta: 'Web portal', tone: 'b2b' },
  { key: 'wa', label: 'WhatsApp', value: '9', meta: 'Queue', tone: 'wa' },
] as const;

const BARS = [42, 68, 55, 78, 46, 90, 62];

const SSL_ROWS = [
  { code: 'A0012', name: 'ABC CATERING PTE LTD', lines: 11 },
  { code: 'A0014', name: 'ORIENTAL FOOD HOUSE', lines: 2 },
  { code: 'A0021-S3', name: 'SUNRISE BAKERY (S3)', lines: 12 },
  { code: 'A0021-S4', name: 'SUNRISE BAKERY (S4)', lines: 9 },
  { code: 'B0237', name: 'BANQUET SERVICES SG', lines: 6 },
];

/**
 * Visual-only content samples for the floating DEM chrome.
 * Shell chrome comes from DemFloatingShell via DemAppShell.
 * Open: /dem/theme-preview
 */
export function DemThemePreviewPage() {
  return (
    <>
      <div className="dem-theme-lab__banner">
        <div>
          <strong>Theme preview only</strong>
          <p>
            Sample content inside the live floating shell. Dashboard (`/dem/analytics`) uses the
            same chrome with real data.
          </p>
        </div>
        <code className="dem-theme-lab__path">/dem/theme-preview</code>
      </div>

      <div className="dem-theme-lab__kpis">
        {KPI.map((kpi, index) => (
          <article
            key={kpi.key}
            className={`dem-theme-lab__kpi dem-theme-lab__kpi--${kpi.tone}`}
            style={{ animationDelay: `${80 + index * 45}ms` }}
          >
            <p className="dem-theme-lab__kpi-label">{kpi.label}</p>
            <p className="dem-theme-lab__kpi-value">{kpi.value}</p>
            <p className="dem-theme-lab__kpi-meta">{kpi.meta}</p>
          </article>
        ))}
      </div>

      <div className="dem-theme-lab__grid">
        <section className="dem-theme-lab__card dem-theme-lab__card--enter">
          <div className="dem-theme-lab__card-head">
            <div>
              <h2>Last 7 days</h2>
              <p>Imported volume (sample)</p>
            </div>
            <div className="dem-theme-lab__pill-row">
              <span className="dem-theme-lab__pill is-active">Daily</span>
              <span className="dem-theme-lab__pill">Monthly</span>
              <span className="dem-theme-lab__pill">Yearly</span>
            </div>
          </div>
          <div className="dem-theme-lab__bars" aria-hidden>
            {BARS.map((h, i) => (
              <div
                key={i}
                className="dem-theme-lab__bar"
                style={{ height: `${h}%`, animationDelay: `${120 + i * 40}ms` }}
              />
            ))}
          </div>
        </section>

        <section
          className="dem-theme-lab__card dem-theme-lab__card--enter"
          style={{ animationDelay: '120ms' }}
        >
          <div className="dem-theme-lab__card-head">
            <div>
              <h2>Std Lines</h2>
              <p>Glass list sample</p>
            </div>
          </div>
          <ul className="dem-theme-lab__list">
            {SSL_ROWS.map((row) => (
              <li key={row.code}>
                <span className="dem-theme-lab__list-code">{row.code}</span>
                <span className="dem-theme-lab__list-name">{row.name}</span>
                <span className="dem-theme-lab__list-count">{row.lines}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <div className="dem-theme-lab__actions">
        <button type="button" className="dem-theme-lab__btn dem-theme-lab__btn--primary">
          Primary action
        </button>
        <button type="button" className="dem-theme-lab__btn">
          Secondary
        </button>
        <button type="button" className="dem-theme-lab__btn">
          Refresh
        </button>
      </div>
    </>
  );
}
